import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges, AfterViewChecked, ViewChild, ViewChildren, AfterViewInit, QueryList, HostListener, ElementRef } from '@angular/core';
import { ProblemMenuInputSuggestion, ProblemMenuItem, ProblemMenuSelection } from '../../store/application';
import { isMobile } from 'src/assets/isMobileChecker';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbAccordion } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-problem-selection',
  templateUrl: './problem-selection.component.html',
  styleUrls: ['./problem-selection.component.scss']
})
export class ProblemSelectionComponent implements OnInit, AfterViewChecked, OnChanges, AfterViewInit {
  @Input() problemMenuItems: ProblemMenuItem[];
  @Input() filteredProblemsItemCount: number;
  @Input() commonSearches: string[];
  @Input() currentStep!: number | null;
  @Input() selectedProblemItem: ProblemMenuSelection | null = null;;
  @Output() updatedProblemMenu = new EventEmitter<ProblemMenuItem[]>();
  @Output() selectedProblemMenuItem = new EventEmitter<ProblemMenuSelection>();
  @Output() filterProblemMenuItems = new EventEmitter<string>();
  @Output() logSearchFieldText = new EventEmitter<string>();
  @Output() goToNextPage = new EventEmitter();
  @Output() triggerProblemIndexSetter = new EventEmitter();

  @Output() triggerIframeExpansion = new EventEmitter();
  @Output() triggerIframeContraction = new EventEmitter();
  @ViewChild('accordion') accordion: NgbAccordion;
  @ViewChildren('accordion2') accordion2: QueryList<NgbAccordion>;
  @ViewChild('accordionMobile') accordionMobile: NgbAccordion;
  @ViewChildren('accordionMobile2') accordionMobile2: QueryList<NgbAccordion>;
  @ViewChild('mobileSearchField') mobileSearchField: ElementRef;

  searchFieldText = '';
  filteredMenuInputSuggestions: ProblemMenuInputSuggestion[] = [];
  isMobile = isMobile;
  isMobileFilterOpen = false;
  lastTabbedElementId: string = '';

  expansionTriggered = false;
  contractionTriggered = false;

  // level1Selected = '';
  level2Selected: string[] = [];
  // mobileMenuClosed = '';
  // searchStringSelected = '';
  // closeOthers = true;
  selectedExpand = false;
  menu1Selected = '';
  menu2Selected = '';

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    document.addEventListener('keydown', (event: KeyboardEvent) => {
      // prevent clicking the space bar from immediately shifting the page to the bottom of the screen
      if ((event.key === 'Spacebar' || event.key === ' ') && (event.target as any).nodeName === 'LI') {
        event.preventDefault();
      }
    });

    document.addEventListener('keyup', (event: KeyboardEvent) => {
      // save the last tabbed element to keep it highlighted after the state update
      if (event.key === 'Tab') {
        let element = (event.target as any);
        this.lastTabbedElementId = element.classList.contains('menuItemElement') ? (element.id || "") : "";
      }
    });

    document.addEventListener('mousemove', () => {
      // if the user is using a mouse, remove the focus outline from the currently focused element
      if (!!this.lastTabbedElementId) {
        let element = document.getElementById(this.lastTabbedElementId);
        element?.blur();
        this.lastTabbedElementId = "";
      }
    });

  }

  ngOnChanges() {
    if (!!this.problemMenuItems) {
      this.triggerProblemIndexSetter.emit();

      if (this.searchFieldText) {

        setTimeout(() => {

          if (this.accordion) {
            this.accordion.closeOtherPanels = false;
            this.accordion.expandAll();
          }
        }, 0);

        setTimeout(() => {
          if (this.accordion2) {
            this.accordion2.forEach(acc => acc.expandAll());
          }
        }, 0);

        // mobile
        setTimeout(() => {

          if (this.accordionMobile) {
            this.accordionMobile.closeOtherPanels = false;
            this.accordionMobile.expandAll();
          }
        }, 0);

        setTimeout(() => {
          if (this.accordionMobile2) {
            this.accordionMobile2.forEach(acc => acc.expandAll());
          }
        }, 0);

      } else {
        setTimeout(() => {

          if (this.accordion) {
            this.accordion.closeOtherPanels = true;
            if (this.selectedProblemItem && this.selectedProblemItem.Group_RefId! === 0) {
              this.accordion.collapseAll();
            }
          }
        }, 0);

        setTimeout(() => {
          if (this.accordion2) {
            if (this.selectedProblemItem && this.selectedProblemItem.Group_RefId! === 0) {
              this.accordion2.forEach(acc => acc.collapseAll());
            }

          }
        }, 0);

        // mobile
        setTimeout(() => {

          if (this.accordionMobile) {
            this.accordionMobile.closeOtherPanels = true;
            if (this.selectedProblemItem && this.selectedProblemItem.Group_RefId! === 0) {
              this.accordionMobile.collapseAll();
            }
          }
        }, 0);

        setTimeout(() => {
          if (this.accordionMobile2) {
            if (this.selectedProblemItem && this.selectedProblemItem.Group_RefId! === 0) {
              this.accordionMobile2.forEach(acc => acc.collapseAll());
            }
          }
        }, 0);
      }
    }
  }

  ngAfterViewChecked(): void {
    // after the state update, if we were focused on an element, re-highlight it
    if (!!this.lastTabbedElementId) {
      let element = document.getElementById(this.lastTabbedElementId);
      element?.focus();
    }

    // if user goes back a step and a problem menu item was selected, open those menus
    if (!this.selectedExpand) {
      if (this.accordion2 && !this.accordion2.dirty) {
        this.accordion2.forEach(acc => {
          acc.panels.forEach(p => {
            if (p.id.indexOf('-open') > -1) {
              acc.expand(p.id);
            }
          });
        });
        this.selectedExpand = true;
      }

      if (this.accordionMobile2 && !this.accordionMobile2.dirty) {
        this.accordionMobile2.forEach(acc => {
          acc.panels.forEach(p => {
            if (p.id.indexOf('-open') > -1) {
              acc.expand(p.id);
            }
          });
        });
      }

    }

  }

  ngAfterViewInit(): void {
    // user comes back after selecting, open appropriate panels
    if (this.accordion) {
      this.accordion.panels.forEach(p => {
        if (p.id.indexOf('-open') > -1) {
          this.accordion.expand(p.id);
        }
      });
    }

    if (this.accordionMobile) {
      this.accordionMobile.panels.forEach(p => {
        if (p.id.indexOf('-open') > -1) {
          this.accordionMobile.expand(p.id);
        }
      });
    }

  }

  getTabIndex(menuLevel1: ProblemMenuItem, menuLevel2?: ProblemMenuItem, menuLevel3?: ProblemMenuItem) {
    let id = this.getMenuId(menuLevel1.menuHead, (menuLevel2?.menuHead || undefined), (menuLevel3?.menuHead || undefined));

    // need to start at one as the filter bar search field has an index of 1
    let index = 1;
    let tabIndexRet = -1;

    this.problemMenuItems.forEach(menu1 => {
      index++;
      if (this.getMenuId(menu1.menuHead) !== id) {

        if (menu1.shouldExpandDropdown || this.isPanelOpenLevel1(menu1.menuHead)) {
          menu1.subMenus.forEach(menu2 => {
            index++;

            if (this.getMenuId(menu1.menuHead, menu2.menuHead) !== id) {

              if (menu2.shouldExpandDropdown || (menuLevel2 && this.isPanelOpenLevel2(menu1.menuHead, menu2.menuHead))) {
                menu2.subMenus.forEach(menu3 => {
                  index++;

                  if (this.getMenuId(menu1.menuHead, menu2.menuHead, menu3.menuHead) === id) {
                    tabIndexRet = index;
                  }
                });
              }

            } else {
              tabIndexRet = index;

            }
          });
        }

      } else {
        tabIndexRet = index;

      }
    });

    return tabIndexRet;
  }

  generateMenuTextHTML(menuItemText: string) {
    if(menuItemText === 'Congested street parking'){
      return menuItemText +    ' (ongoing street parking issue)';
    } else if(menuItemText === 'Illegally parked vehicle'){
      return menuItemText +    ' (time sensitive, bylaw enforcement issue)';
    }

    if (this.searchFieldText.length === 0) {

      return menuItemText;
    }

    let innerTextArr = menuItemText.split(" ");
    return this.generateFilteredMenuLevelHTML(innerTextArr, menuItemText);
  }

  generateFilteredMenuLevelHTML(innerTextArr: string[], originalText: string = ""): string {

    let newInnerHTML = "";
    innerTextArr.forEach((textFragment: string) => {

      let startingIndex = textFragment.toLowerCase().indexOf(this.searchFieldText.toLowerCase());
      if (startingIndex === 0) {
        let matchingPart = textFragment.substring(0, this.searchFieldText.length);
        let remainder = textFragment.substring(this.searchFieldText.length);
        newInnerHTML += `<strong>${matchingPart}</strong>${remainder} `;

      } else {
        newInnerHTML += `${textFragment} `
      }
    });

    if (newInnerHTML.trim() === originalText) {
      return this.generateFilteredMenuLevelHTML([originalText]);
    }

    return newInnerHTML.trim();
  }

  handleToggleSliderWindow(event: any) {
    if (!isMobile.any()) {
      return;
    }

    if (!!event) {
      event.preventDefault();
    }

    let slideWindow = document.getElementById("slideWindow");
    slideWindow?.classList.toggle("close");
    this.isMobileFilterOpen = false;

    if (!slideWindow?.classList.contains("close")) {

      // prevent multiple calls from bombarding the postMessage
      if (!this.expansionTriggered) {
        this.triggerIframeExpansion.emit();
        this.expansionTriggered = true;
        this.contractionTriggered = false;
      }

      setTimeout(() => {
        //document.getElementById("mobileSearchField")?.focus(), 1000
        this.mobileSearchField.nativeElement.focus();
      }, 500);
      this.isMobileFilterOpen = true;

    } else {

      // prevent multiple calls from bombarding the postMessage
      if (!this.contractionTriggered) {
        this.triggerIframeContraction.emit();
        this.contractionTriggered = true;
        this.expansionTriggered = false;
      }

      this.searchFieldText = "";
      this.filterProblemMenuItems.emit(this.searchFieldText);
    }
  }

  handleClearSearchFieldText() {
    this.searchFieldText = "";
    this.filterProblemMenuItems.emit(this.searchFieldText);
  }

  handleCommonSearch(searchItem: string) {
    this.searchFieldText = searchItem;
    this.filterProblemMenuItems.emit(this.searchFieldText);
  }

  updateSearchFieldFilter() {

    if (this.searchFieldText.split(" ").some(text => text.length >= 3)) {
      this.logSearchFieldText.emit(this.searchFieldText);
    }

    this.filterProblemMenuItems.emit(this.searchFieldText.trim());
  }

  selectSuggestion(suggestion: ProblemMenuInputSuggestion) {
    this.filteredMenuInputSuggestions = [];
    this.searchFieldText = suggestion.suggestionText;

    this.selectedProblemMenuItem.emit({
      ...suggestion.menuItem,
      selected: true
    });
  }

  handleKeypress(event: KeyboardEvent, menuLevel1: ProblemMenuItem, menuLevel2?: ProblemMenuItem, menuLevel3?: ProblemMenuItem) {

    // If spacebar fired the event
    if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
      if (!!menuLevel3) {
        this.onLevelThreeMenuItemSelect(menuLevel3);
      } else if (!!menuLevel2) {
        this.onLevelTwoMenuItemSelect(menuLevel1, menuLevel2);
      } else {
        this.onLevelOneMenuItemSelect(menuLevel1);
      }
    }
  }

  handleMouseDown(event: MouseEvent) {
    event.preventDefault();
  }

  getCollapsedProblemMenu() {
    let menuCopy = JSON.parse(JSON.stringify(this.problemMenuItems));
    if (!this.isMobileFilterOpen) {

      menuCopy.forEach((menuLevel1: ProblemMenuItem) => {
        if (!!menuLevel1.subMenus) {
          menuLevel1.shouldExpandDropdown = false;

          // menuLevel1.subMenus.forEach(menuLevel2 => {
          //   if (!!menuLevel2.subMenus) {
          //     menuLevel2.shouldExpandDropdown = false;
          //   }
          // })
        }
      });
    }

    return menuCopy;
  }

  onLevelOneMenuItemSelect(menuLevel1: ProblemMenuItem) {
    // Check to make sure that the selected entry is a menuItem with selectable subMenus or not
    const updatedProblemMenu = [...this.getCollapsedProblemMenu()];

    if (menuLevel1.menuItem === null) {
      const updatedMenuItem: ProblemMenuItem = {
        ...menuLevel1,
        shouldExpandDropdown: !menuLevel1.shouldExpandDropdown
      }

      const menuIndex = this.problemMenuItems.findIndex(problemMenuItem => problemMenuItem.menuHead === menuLevel1.menuHead);
      updatedProblemMenu[menuIndex] = updatedMenuItem;
      //this.updatedProblemMenu.emit(updatedProblemMenu);

      this.menu1Selected = this.menu1Selected + ' ' + menuLevel1.menuHead;
    } else {
      if (isMobile.any()) {
        this.triggerIframeContraction.emit();
        this.contractionTriggered = true;
        this.expansionTriggered = false;
      }

      this.updatedProblemMenu.emit(updatedProblemMenu);
      this.selectedProblemMenuItem.emit({
        ...menuLevel1.menuItem,
        selected: true
      });

      // if (this.isMobileFilterOpen) {
      this.goToNextPage.emit();
      // }
    }
  }

  onLevelTwoMenuItemSelect(menuLevel1: ProblemMenuItem, menuLevel2: ProblemMenuItem) {
    if (menuLevel2.menuItem === null) {
      let updatedMenuOneItem: ProblemMenuItem = {
        menuHead: menuLevel1.menuHead,
        menuItem: menuLevel1.menuItem,
        subMenus: [...menuLevel1.subMenus],
        shouldExpandDropdown: menuLevel1.shouldExpandDropdown,
        selected: false
      }

      this.menu2Selected = this.menu2Selected + ' ' + menuLevel2.menuHead;

      let updatedMenuTwoItem: ProblemMenuItem = {
        ...menuLevel2,
        shouldExpandDropdown: !menuLevel2.shouldExpandDropdown
      };

      const menuTwoIndex = menuLevel1.subMenus.findIndex(menuItem => menuItem.menuHead === menuLevel2.menuHead);
      updatedMenuOneItem.subMenus[menuTwoIndex] = updatedMenuTwoItem;

      const menuIndex = this.problemMenuItems.findIndex(problemMenuItem => problemMenuItem.menuHead === menuLevel1.menuHead);
      const updatedProblemMenu = [...this.problemMenuItems];
      updatedProblemMenu[menuIndex] = updatedMenuOneItem;
      // this.updatedProblemMenu.emit(updatedProblemMenu);
    } else {
      if (isMobile.any()) {
        this.triggerIframeContraction.emit();
        this.contractionTriggered = true;
        this.expansionTriggered = false;
      }

      this.selectedProblemMenuItem.emit({
        ...menuLevel2.menuItem,
        selected: true
      });

      // if (this.isMobileFilterOpen) {
      this.goToNextPage.emit();
      // }
    }
  }

  onLevelThreeMenuItemSelect(menuLevel3: ProblemMenuItem) {
    if (isMobile.any()) {
      this.triggerIframeContraction.emit();
      this.contractionTriggered = true;
      this.expansionTriggered = false;
    }

    this.selectedProblemMenuItem.emit({
      ...menuLevel3.menuItem!,
      selected: true
    });

    // if (this.isMobileFilterOpen) {
    this.goToNextPage.emit();
    // }
  }

  cleanMenuHead(menuHead: string): string {
    return menuHead.replace(/,|\s/g, '');
  }

  getMenuId(menuOneHead?: string, menuTwoHead?: string, menuThreeHead?: string): string {
    let id = '';
    if (menuOneHead) {
      id += this.cleanMenuHead(menuOneHead);
    }

    if (menuTwoHead) {
      id += `-${this.cleanMenuHead(menuTwoHead)}`;
    }

    if (menuThreeHead) {
      id += `-${this.cleanMenuHead(menuThreeHead)}`;
    }

    return id;
  }

  // getExpandCollapseIcon(menuItem: ProblemMenuItem): string {
  //   if (menuItem.shouldExpandDropdown) {
  //     return '<i class="fas fa-minus"></i>';
  //   } else {
  //     return '<i class="fas fa-plus"></i>';
  //   }
  // }

  getIcon(menuOne: string) {
    let icon = '';
    switch (menuOne) {
      case 'Animals':
        // icon = '<i class="fas fa-paw"></i>';
        icon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M256 224c-79.37 0-191.1 122.7-191.1 200.2C64.02 459.1 90.76 480 135.8 480C184.6 480 216.9 454.9 256 454.9C295.5 454.9 327.9 480 376.2 480c44.1 0 71.74-20.87 71.74-55.75C447.1 346.8 335.4 224 256 224zM376.2 448c-20.25 0-37.75-5.75-56.37-11.88C300.2 429.6 279.9 422.9 256 422.9c-23.62 0-43.87 6.75-63.37 13.12C174 442.2 156.4 448 135.8 448C96.01 448 96.01 430.1 96.01 424.2C96.01 361.4 196.3 256 256 256s159.1 105.4 159.1 168.2C415.1 430.1 415.1 448 376.2 448zM474.9 161.3c-3.625-.875-7.24-1.26-10.86-1.26c-25.87 0-51.63 21.01-60.75 51.38c-10.37 34.63 4.75 68.37 33.87 75.37c3.625 .875 7.238 1.259 10.86 1.259c25.87 0 51.63-21.01 60.76-51.38C519.1 202 503.1 168.3 474.9 161.3zM478.1 227.4C472.7 245.2 458.5 256 447.1 256c-1.125 0-2.25-.125-3.375-.375c-3.75-.875-6.749-3.375-8.999-7.25c-4.125-7.25-4.75-17.62-1.75-27.75C439.2 202.8 453.5 192 463.1 192c1.25 0 2.375 .125 3.375 .375c3.75 .875 6.75 3.375 8.999 7.25C480.5 206.9 481.1 217.2 478.1 227.4zM318.5 190.6C322.1 191.5 325.7 192 329.3 192c27.75 0 56.16-26.88 66.66-65.25c11.87-43.38-3.625-85.25-34.5-93.37C357.9 32.5 354.3 32 350.7 32c-27.75 0-56.16 26.75-66.66 65.25C272.1 140.6 287.6 182.5 318.5 190.6zM314.9 105.6C322.2 78.5 340.4 64 350.6 64c.9999 0 1.875 .125 2.625 .375c4.125 1 7.124 5 8.999 8c4.1 8.875 8.499 25.5 2.875 46C357.7 145.5 339.6 160 329.2 160c-.8749 0-1.75-.125-2.5-.375c-4.125-1-7.124-5-8.999-8C312.7 142.8 309.2 126.1 314.9 105.6zM182.7 192c3.625 0 7.207-.5006 10.83-1.376C224.4 182.5 239.9 140.6 228 97.25C217.5 58.88 189.1 32 161.3 32C157.7 32 154.1 32.5 150.5 33.38c-30.87 8.125-46.37 49.1-34.5 93.37C126.5 165.1 154.9 192 182.7 192zM149.8 72.38c1.875-3 4.875-7 8.999-8C159.5 64.12 160.4 64 161.3 64c10.37 0 28.5 14.5 35.87 41.62c5.625 20.5 2.125 37.13-2.875 45.1c-1.875 3-4.875 7-8.999 8C184.5 159.9 183.6 160 182.6 160C172.4 160 154.3 145.5 146.9 118.4C141.3 97.88 144.8 81.25 149.8 72.38zM74.89 286.8c29.12-7 44.25-40.75 33.87-75.37C99.64 181 73.88 159.1 48.01 159.1c-3.625 0-7.24 .3849-10.86 1.26c-29.12 7-44.25 40.75-33.87 75.37c9.124 30.38 34.88 51.38 60.76 51.38C67.65 288 71.26 287.6 74.89 286.8zM33.89 227.4C30.89 217.2 31.52 206.8 35.64 199.6C37.89 195.8 40.89 193.2 44.64 192.4C45.77 192.1 46.89 192 48.02 192c10.5 0 24.75 10.75 30.12 28.62c2.1 10.13 2.375 20.5-1.75 27.75C74.14 252.2 71.14 254.8 67.39 255.6C66.26 255.9 65.26 256 64.02 256C53.52 256 39.27 245.2 33.89 227.4z"/></svg>';
        break;

      case 'Construction':
        // icon = '<i class="fas fa-hard-hat"></i>';
        icon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M571.7 357.2c-3.016-3.188-7.219-5.031-11.61-5.031c-75.28-.2187-544 0-544 0c-4.406 0-8.609 1.812-11.64 5.031c-3.031 3.188-4.594 7.531-4.328 11.94C4.359 441.4 170 480 287.1 480h3.281c114.9 0 280.4-39 284.7-110.9C576.2 364.7 574.7 360.4 571.7 357.2zM291.5 448c-1.156 0-2.202 .25-3.484 0c-104.5 0-215.9-30.44-247.4-63.84C102.3 384.3 461.6 384 535.4 384.1C504 417.3 393.1 448 291.5 448zM48 320C56.84 320 64 312.8 64 304V274.9c0-89.27 59.69-165.8 144-189.9V272C208 280.8 215.2 288 224 288C232.8 288 240 280.8 240 272V64c0-8.812 7.172-16 16-16h64c8.828 0 16 7.188 16 16v208c0 8.844 7.156 16 15.1 16S368 280.8 368 272V84.94c84.31 24.1 144 100.7 144 189.9V304c0 8.844 7.156 16 16 16s16.01-7.156 16.01-16L544 274.9c0-107.6-74.29-199.9-178.1-224.1C360.1 30.76 341.8 16 320 16H256c-21.85 0-40.13 14.76-45.91 34.77C106.3 74.94 32 167.3 32 274.9L31.99 304C31.99 312.8 39.16 320 48 320z"/></svg>';
        break;

      case 'Garbage, litter, pollution':
        // icon = '<i class="fas fa-trash-alt"></i>';
        icon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M432 64C440.8 64 448 71.16 448 80C448 88.84 440.8 96 432 96H413.7L388.2 452.6C385.9 486.1 357.1 512 324.4 512H123.6C90.01 512 62.15 486.1 59.75 452.6L34.29 96H16C7.164 96 0 88.84 0 80C0 71.16 7.164 64 16 64H111.1L137 22.56C145.8 8.526 161.2 0 177.7 0H270.3C286.8 0 302.2 8.526 310.1 22.56L336.9 64H432zM177.7 32C172.2 32 167.1 34.84 164.2 39.52L148.9 64H299.1L283.8 39.52C280.9 34.84 275.8 32 270.3 32H177.7zM381.6 96H66.37L91.67 450.3C92.87 467 106.8 480 123.6 480H324.4C341.2 480 355.1 467 356.3 450.3L381.6 96z"/></svg>';
        break;

      case 'Graffiti':
        // icon = '<i class="fas fa-spray-can"></i>';
        icon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M80 320C80 275.8 115.8 240 160 240C204.2 240 240 275.8 240 320C240 364.2 204.2 400 160 400C115.8 400 80 364.2 80 320zM160 368C186.5 368 208 346.5 208 320C208 293.5 186.5 272 160 272C133.5 272 112 293.5 112 320C112 346.5 133.5 368 160 368zM96 128V32C96 14.33 110.3 0 128 0H192C209.7 0 224 14.33 224 32V128C277 128 320 170.1 320 224V440C320 479.8 287.8 512 248 512H72C32.24 512 0 479.8 0 440V224C0 170.1 42.98 128 96 128zM128 128H192V32H128V128zM224 160H96C60.65 160 32 188.7 32 224V440C32 462.1 49.91 480 72 480H248C270.1 480 288 462.1 288 440V224C288 188.7 259.3 160 224 160zM312 64C312 77.25 301.3 88 288 88C274.7 88 264 77.25 264 64C264 50.75 274.7 40 288 40C301.3 40 312 50.75 312 64zM360 64C360 50.75 370.7 40 384 40C397.3 40 408 50.75 408 64C408 77.25 397.3 88 384 88C370.7 88 360 77.25 360 64zM504 64C504 77.25 493.3 88 480 88C466.7 88 456 77.25 456 64C456 50.75 466.7 40 480 40C493.3 40 504 50.75 504 64zM456 160C456 146.7 466.7 136 480 136C493.3 136 504 146.7 504 160C504 173.3 493.3 184 480 184C466.7 184 456 173.3 456 160zM504 256C504 269.3 493.3 280 480 280C466.7 280 456 269.3 456 256C456 242.7 466.7 232 480 232C493.3 232 504 242.7 504 256zM360 160C360 146.7 370.7 136 384 136C397.3 136 408 146.7 408 160C408 173.3 397.3 184 384 184C370.7 184 360 173.3 360 160z"/></svg>';
        break;

      case 'Illegal or hazardous use of property':
      case 'Illegal or hazardous use of private property':
        // icon = '<i class="fas fa-exclamation-circle"></i>';
        icon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M256 360c-13.25 0-23.1 10.74-23.1 24c0 13.25 10.75 24 23.1 24c13.25 0 23.1-10.75 23.1-24C280 370.7 269.3 360 256 360zM256 320c8.843 0 15.1-7.156 15.1-16V160c0-8.844-7.155-16-15.1-16S240 151.2 240 160v144C240 312.8 247.2 320 256 320zM504.3 397.3L304.5 59.38C294.4 42.27 276.2 32.03 256 32C235.8 32 217.7 42.22 207.5 59.36l-199.9 338c-10.05 16.97-10.2 37.34-.4218 54.5C17.29 469.5 35.55 480 56.1 480h399.9c20.51 0 38.75-10.53 48.81-28.17C514.6 434.7 514.4 414.3 504.3 397.3zM476.1 435.1C472.7 443.5 464.8 448 455.1 448H56.1c-8.906 0-16.78-4.484-21.08-12c-4.078-7.156-4.015-15.3 .1562-22.36L235.1 75.66C239.4 68.36 247.2 64 256 64c0 0-.0156 0 0 0c8.765 .0156 16.56 4.359 20.86 11.64l199.9 338C480.1 420.7 481.1 428.8 476.1 435.1z"/></svg>';
        break;

      case 'Noise':
        // icon = '<i class="fas fa-bullhorn"></i>';
        icon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M333.2 34.84c-4.201-1.895-8.727-2.841-13.16-2.841c-7.697 0-15.29 2.784-21.27 8.1L163.8 160H80c-26.51 0-48 21.49-48 47.1v95.1c0 26.51 21.49 47.1 48 47.1h83.84l134.9 119.9C304.7 477.2 312.3 480 320 480c4.438 0 8.959-.9312 13.16-2.837C344.7 472 352 460.6 352 448V64C352 51.41 344.7 39.1 333.2 34.84zM319.1 447.1L175.1 319.1H80c-8.822 0-16-7.16-16-15.96v-96c0-8.801 7.178-15.96 16-15.96h95.1l143.1-127.1c.0078-.0078-.0039 .0039 0 0L319.1 447.1zM491.4 98.7c-7.344-4.922-17.28-2.953-22.2 4.391s-2.953 17.28 4.391 22.2C517.7 154.8 544 203.7 544 256s-26.33 101.2-70.44 130.7c-7.344 4.922-9.312 14.86-4.391 22.2C472.3 413.5 477.3 416 482.5 416c3.062 0 6.156-.875 8.891-2.703C544.4 377.8 576 319 576 256S544.4 134.2 491.4 98.7zM438.4 178.7c-7.328-4.922-17.28-2.953-22.2 4.391s-2.953 17.28 4.391 22.2C437.8 216.8 448 235.7 448 256s-10.23 39.23-27.38 50.7c-7.344 4.922-9.312 14.86-4.391 22.2C419.3 333.5 424.4 336 429.5 336c3.062 0 6.156-.875 8.891-2.703C464.5 315.9 480 286.1 480 256S464.5 196.1 438.4 178.7z"/></svg>';
        break;

      case 'Parking and vehicles':
        // icon = '<i class="fas fa-car"></i>';
        icon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M80 296C80 282.7 90.75 272 104 272C117.3 272 128 282.7 128 296C128 309.3 117.3 320 104 320C90.75 320 80 309.3 80 296zM432 296C432 309.3 421.3 320 408 320C394.7 320 384 309.3 384 296C384 282.7 394.7 272 408 272C421.3 272 432 282.7 432 296zM48.29 204.7L82.99 89.01C93.14 55.17 124.3 32 159.6 32H352.4C387.7 32 418.9 55.17 429 89.01L463.7 204.7C492.6 221.2 512 252.3 512 288V464C512 472.8 504.8 480 496 480C487.2 480 480 472.8 480 464V416H32V464C32 472.8 24.84 480 16 480C7.164 480 0 472.8 0 464V288C0 252.3 19.44 221.2 48.29 204.7zM85.33 192.6C88.83 192.2 92.39 192 96 192H416C419.6 192 423.2 192.2 426.7 192.6L398.4 98.21C392.3 77.9 373.6 64 352.4 64H159.6C138.4 64 119.7 77.9 113.6 98.21L85.33 192.6zM32 288V384H480V288C480 260.3 462.4 236.7 437.7 227.8L437.3 227.9L437.2 227.6C430.5 225.3 423.4 224 416 224H96C88.58 224 81.46 225.3 74.83 227.6L74.73 227.9L74.27 227.8C49.62 236.7 32 260.3 32 288V288z"/></svg>';
        break;

      case 'Parks':
        // icon = '<i class="fas fa-biking"></i>';
        icon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M410.4 288c-11.43 0-19.17 11.63-14.75 22.17l53.59 128C451.8 444.3 457.8 448 464 448c2.062 0 4.156-.4062 6.188-1.25c8.156-3.406 11.97-12.78 8.562-20.94l-53.58-127.1C422.7 291.9 416.9 288 410.4 288zM33.25 425.8c-3.406 8.156 .4062 17.53 8.562 20.94C43.84 447.6 45.94 448 48 448c6.25 0 12.19-3.688 14.75-9.812L116.3 310.2C120.7 299.6 113 288 101.6 288C95.14 288 89.32 291.9 86.83 297.8L33.25 425.8zM496 224h-101.8l-53.56-128H432C440.8 96 448 88.84 448 80C448 71.16 440.8 64 432 64h-352C71.16 64 64 71.16 64 80C64 88.84 71.16 96 80 96h91.31L117.8 224H16C7.164 224 0 231.2 0 240C0 248.8 7.164 256 16 256h480C504.8 256 512 248.8 512 240C512 231.2 504.8 224 496 224zM152.4 224l53.58-128h100l53.58 128H152.4z"/></svg>';
        break;

      case 'Streets and sidewalks':
        // icon = '<i class="fas fa-road"></i>';
        icon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M304 304C304 312.8 296.8 320 288 320C279.2 320 272 312.8 272 304V208C272 199.2 279.2 192 288 192C296.8 192 304 199.2 304 208V304zM390.4 32C417.3 32 441.3 48.79 450.5 74.04L567.5 394C582.7 435.8 551.8 480 507.4 480H68.64C24.19 480-6.728 435.8 8.529 394L125.5 74.04C134.7 48.79 158.7 32 185.6 32H390.4zM38.59 405C30.96 425.9 46.41 448 68.64 448H271.1V400C271.1 391.2 279.2 384 287.1 384C296.8 384 304 391.2 304 400V448H507.4C529.6 448 545 425.9 537.4 405L420.5 85.02C415.9 72.4 403.9 64 390.4 64H304V112C304 120.8 296.8 128 287.1 128C279.2 128 271.1 120.8 271.1 112V64H185.6C172.1 64 160.1 72.4 155.5 85.02L38.59 405z"/></svg>';
        break;

      case 'Trees and plants':
        // icon = '<i class="fas fa-tree"></i>';
        icon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M496 235c-10.62-16-42-35-42-35c8.625-16 11.88-32.5 9.5-49.5s-9.125-31.62-20.5-44s-25.12-20.5-41.5-24.5c-5.799-1.418-11.61-2.129-17.45-2.129c-10.63 0-21.32 2.365-32.05 7.129c-2.625-24.63-13.12-45.38-31.5-62S280.6 0 256 0S209.9 8.375 191.5 25S162.6 62.38 160 87C149.3 82.24 138.6 79.87 127.9 79.87c-5.83 0-11.65 .713-17.45 2.129c-16.38 4-30.12 12.12-41.5 24.5s-18.12 27-20.5 44s1.125 33.5 10.5 49.5c-18 7.375-32.38 19-43 35S0 268.6 0 288c0 26.62 9.375 49.38 28 68s41.38 28 68 28L240 384v112c0 8.844 7.26 16 16.1 16S272 504.8 272 496V384l144 0c26.62 0 49.38-9.375 68-28S512 314.6 512 288C512 268.6 506.6 251 496 235zM461.4 333.4C448.7 346.1 434.2 352 416 352h-144v-25.38l59.31-59.31c6.25-6.25 6.25-16.38 0-22.62s-16.38-6.25-22.62 0L272 281.4V144c0-8.844-7.165-16.01-16.01-16.01S240 135.2 240 144v82.38L204.5 182c-5.531-6.844-15.58-8-22.5-2.5C175.1 185 173.1 195.1 179.5 202L240 277.6V352H96c-18.25 0-32.66-5.92-45.37-18.63C37.92 320.7 32 306.2 32 288c0-12.95 3.486-24.5 10.66-35.3c7.014-10.56 16.33-18.11 28.47-23.09l34.12-13.98L86.61 183.8C80.85 173.1 78.81 164.8 80.19 154.9c1.496-10.71 5.426-19.22 12.37-26.77c7.143-7.77 15.26-12.56 25.54-15.07C121.4 112.3 124.7 111.9 127.9 111.9c6.195 0 12.44 1.434 19.08 4.379L187.2 134.1l4.654-43.67c1.787-16.78 8.705-30.4 21.15-41.66C225.6 37.31 239.3 32 256 32s30.42 5.314 43.03 16.73c12.44 11.26 19.36 24.89 21.15 41.66L324.8 134.1l40.14-17.81c6.643-2.945 12.88-4.379 19.08-4.379c3.283 0 6.504 .3984 9.848 1.215c10.28 2.51 18.39 7.299 25.54 15.07c6.939 7.551 10.87 16.06 12.37 26.77c1.402 10.05-.5508 19.83-5.977 29.89l-14.39 26.76l25.95 15.79c11.99 7.293 28.06 19.5 31.94 25.35C476.5 263.5 480 275 480 288C480 306.2 474.1 320.7 461.4 333.4z"/></svg>';
        break;

      case 'Water and sewer':
        // icon = '<i class="fas fa-water"></i>';
        icon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M562 415.1c-28.14-3.625-53.29-18.34-69.03-40.38c-6-8.438-20.04-8.438-26.04 0C448.5 400.6 417.5 416 383.1 416c-33.52 0-64.53-15.44-82.97-41.28c-6.031-8.438-20.03-8.438-26.06 0C256.5 400.6 225.5 416 192 416c-33.51 0-64.53-15.44-82.97-41.28C106 370.5 101.2 368 96 368s-10.02 2.5-13.02 6.719c-15.73 22.03-40.89 36.75-69.03 40.38c-8.766 1.125-14.95 9.156-13.83 17.94c1.125 8.75 9.029 15.06 17.92 13.81c29.98-3.875 57.48-17.47 77.94-38.09c24.62 24.84 59.28 39.25 96.06 39.25c36.77 0 71.33-14.41 95.95-39.25C312.6 433.6 347.3 448 384.1 448c36.78 0 71.33-14.41 95.95-39.25c20.45 20.62 47.95 34.22 77.94 38.09c8.951 1.375 16.79-5.062 17.92-13.81C576.1 424.3 570.8 416.2 562 415.1zM18.05 142.8c29.98-3.875 57.48-17.47 77.94-38.09C120.6 129.6 155.2 144 192 144C228.8 144 263.4 129.6 288 104.8C312.6 129.6 347.2 144 383.1 144c36.78 0 71.39-14.41 96.01-39.25c20.45 20.62 47.95 34.22 77.94 38.09c8.951 1.375 16.79-5.062 17.92-13.81c1.125-8.781-5.062-16.81-13.83-17.94c-28.14-3.625-53.29-18.34-69.03-40.38c-6-8.438-20.04-8.438-26.04 0c-18.44 25.84-49.38 41.21-82.89 41.21c-33.52 0-64.6-15.36-83.04-41.21c-6.031-8.438-20.03-8.438-26.06 0c-18.44 25.84-49.38 41.21-82.9 41.21c-33.51 0-64.6-15.36-83.04-41.21C106 66.5 101.2 64 95.1 64C90.83 64 85.99 66.5 82.99 70.72c-15.73 22.03-40.89 36.75-69.03 40.38C5.193 112.2-.9922 120.3 .1328 129C1.258 137.8 9.162 144.1 18.05 142.8zM562 263.1c-28.14-3.625-53.29-18.34-69.03-40.38c-6-8.438-20.04-8.438-26.04 0C448.5 248.6 417.5 264 383.1 264c-33.52 0-64.53-15.44-82.97-41.28c-6.031-8.438-20.03-8.438-26.06 0C256.5 248.6 225.5 264 192 264c-33.51 0-64.53-15.44-82.97-41.28C106 218.5 101.2 216 96 216S85.99 218.5 82.99 222.7c-15.73 22.03-40.89 36.75-69.03 40.38C5.193 264.2-.9922 272.3 .1328 281c1.125 8.75 9.029 15.06 17.92 13.81c29.98-3.875 57.48-17.47 77.94-38.09C120.6 281.6 155.2 296 192 296C228.8 296 263.4 281.6 288 256.8C312.6 281.6 347.2 296 383.1 296c36.78 0 71.39-14.41 96.01-39.25c20.45 20.62 47.95 34.22 77.94 38.09c8.951 1.375 16.79-5.062 17.92-13.81C576.1 272.3 570.8 264.2 562 263.1z"/></svg>';
        break;

      default:
        icon = '';
    }

    return this.sanitizer.bypassSecurityTrustHtml(icon);
  }

  generateId(expand: any, level1?: string, level2?: string, level3?: string): string {
    let pnlId = this.getMenuId(level1, level2, level3);
    if (expand) {
      pnlId = pnlId + '-open';
    }
    return pnlId;
  }

  isPanelOpenLevel1(level1?: string): boolean {
    let isOpen = false;
    const pnlId = this.getMenuId(level1);
    this.accordion.panels.forEach(p => {
      if (p.id.indexOf(pnlId) > -1) {
        if (p.shown) {
          isOpen = true;
        }
      }
    });
    return isOpen;
  }

  isPanelOpenLevel2(level1?: string, level2?: string): boolean {
    let isOpen = false;
    const pnlId = this.getMenuId(level1, level2);
    this.accordion2.forEach(acc => {
      acc.panels.forEach(p => {
        if (p.id.indexOf(pnlId) > -1) {
          if (p.shown) {
            isOpen = true;
          }
        }
      });
    });

    return isOpen;
  }

}
